/* eslint-disable import/no-webpack-loader-syntax */

import React, { Component } from "react";
import { Terminal } from "../components/Terminal";
import CatalogWireframe from "../assets/images/background/bg_wireframe_catalog-static.svg.js";
import classnames from "classnames";
import Vivus from "vivus";

import "./ApplicationWindow.css";

const PHASE = {
  HIDDEN: 0, // Waiting until the element enters the viewport (relevant for mobile screens).
  VISIBLE: 1, // Element is inside the viewport, animation in the terminal can begin.
  RUNNING: 2, // Animation in the terminal has finished ("Catalog is running"), we begin showing the browser frame.
  DONE: 3 // Finished the last transition, can show the browser SVG image.
};

// Time between RUNNING and DONE. Small delay to allow the CSS transition to finish before
// showing the (animated) SVG inside the browser frame.
const SVG_TIMEOUT = 1000;

export class ApplicationWindows extends Component {
  constructor(props) {
    super(props);
    this.state = { phase: PHASE.HIDDEN };

    this.ref = null;
    this.refFn = ref => {
      this.ref = ref;
      this.checkVisibility();
    };

    this.wireframe = null;
    this.wireframeFn = ref => {
      this.wireframe = ref;
    };

    this.checkVisibility = () => {
      if (this.ref && this.state.phase === PHASE.HIDDEN && !this.timeoutId) {
        const { top } = this.ref.getBoundingClientRect();
        if (top < window.innerHeight * 2 / 3) {
          this.setState({ phase: PHASE.VISIBLE });
        }
      }
    };

    this.terminalAnimationEnded = () => {
      this.setState({ phase: PHASE.RUNNING });
      this.timeoutId = setTimeout(() => {
        this.timeoutId = null;
        this.setState({ phase: PHASE.DONE }, () => {
          // By now the UI has been re-rendered, the SVG should be inside the DOM
          // and 'this.wireframe' should be a ref to the DOM SVG element. We can
          // trigger the SVG animation now.
          if (this.wireframe !== null) {
            new Vivus(this.wireframe, {
              type: "oneByOne",
              duration: 32,
              pathTimingFunction: Vivus.EASE_OUT_BOUNCE // Assuming this is the same as ease-in-out!
            });
          }
        });
      }, SVG_TIMEOUT);
    };

    this.timeoutId = null;
  }

  componentDidMount() {
    window.addEventListener("scroll", this.checkVisibility);
    this.checkVisibility();
  }

  componentWillUmount() {
    window.removeEventListener("scroll", this.checkVisibility);
    if (this.timeoutId !== null) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
  }

  render() {
    let terminal = (
      <ApplicationFrame id="terminalApplicationFrame" dark>
        <Terminal
          active={this.state.phase >= PHASE.VISIBLE}
          onEnd={this.terminalAnimationEnded}
        />
      </ApplicationFrame>
    );
    let browser = (
      <ApplicationFrame id="browserApplicationFrame">
        {this.state.phase >= PHASE.DONE &&
          CatalogWireframe({
            ref: this.wireframeFn,
            className: "catalogWireframe"
          })}
      </ApplicationFrame>
    );

    const className = classnames({
      ApplicationWindows: true,
      "ApplicationWindows--hidden": !(this.state.phase >= PHASE.RUNNING)
    });

    return (
      <div className={className} ref={this.refFn}>
        <div className="ApplicationWindow ApplicationWindowLeft">
          {terminal}
        </div>
        <div className="ApplicationWindow ApplicationWindowRight">
          {browser}
        </div>
      </div>
    );
  }
}

export const ApplicationFrame = ({ children, dark, id }) => {
  const themeName = classnames({
    ApplicationFrame: true,
    ApplicationFrameDark: dark
  });
  return (
    <div className={themeName} id={id}>
      <div className="ApplicationHead">
        <svg width="32px" height="6px">
          <circle cx="3" cy="3" r="3" />
          <circle cx="14" cy="3" r="3" />
          <circle cx="25" cy="3" r="3" />
        </svg>
      </div>
      <div className="ApplicationBody">{children}</div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/ApplicationWindow.js